const urljoin = require('url-join');

const APP_PATH = '/app';
const CLAIMS_PATH = urljoin(APP_PATH, 'claims');
const PROFILE_PATH = urljoin(APP_PATH, 'profile');
const ACCOUNTS_PATH = urljoin(APP_PATH, 'accounts');
const STORES_PATH = urljoin(APP_PATH, 'stores');
const CHANNELS_PATH = urljoin(APP_PATH, 'channels');
const ALERTS_PATH = urljoin(APP_PATH, 'alerts');

function claimPath(claimId: string = ':id'): string {
  return urljoin(CLAIMS_PATH, claimId);
}

function alertPath(alertId: string = ':id'): string {
  return urljoin(ALERTS_PATH, alertId);
}

export {
  APP_PATH,
  CLAIMS_PATH,
  PROFILE_PATH,
  ACCOUNTS_PATH,
  STORES_PATH,
  CHANNELS_PATH,
  ALERTS_PATH,
  claimPath,
  alertPath,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helpers/routes.ts